import {
    AfterViewInit,
    Component,
    ElementRef,
    forwardRef,
    Input,
    OnDestroy,
    ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as vanillaTextMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Component({
    selector: 'col-phone-input',
    templateUrl: './telefone-input.component.html',
    styleUrls: ['./telefone-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PhoneInputComponent),
            multi: true
        }
    ]
})
export class PhoneInputComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {
    @Input() id: string;
    @Input() name: string;
    @Input() placeholder: string;
    @Input() required: boolean;

    @ViewChild('input') input: ElementRef;

    private maskedInputController: any;
    private onChange: any = () => { };
    private onTouched: any = () => { };

    public getPhoneMask(rawValue: string): (RegExp | string)[] {
        const numbers = rawValue.replace(/\D/g, '');

        if (numbers.length === 10) {
            return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
        return ['(', /\d/, /\d/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }

    ngAfterViewInit() {
        this.initMask();
    }

    ngOnDestroy() {
        this.destroyMask();
    }

    writeValue(obj: any) {
        if (this.input && obj) {
            this.input.nativeElement.value = obj;
        }
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean) {
        this.input.nativeElement.disabled = isDisabled;
    }

    private initMask() {
        this.maskedInputController = vanillaTextMask.maskInput({
            inputElement: this.input.nativeElement,
            mask: this.getPhoneMask,
            placeholderChar: '\u2000',
            guide: true
        });

        this.input.nativeElement.addEventListener('blur', () => {
            this.onTouched();
            this.onChange(this.input.nativeElement.value);
        });
    }

    private destroyMask() {
        if (this.maskedInputController) {
            this.maskedInputController.destroy();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/telefone-input/telefone-input.component.ts